import Vue from 'vue'
import VueI18n from 'vue-i18n'
import Cookies from 'js-cookie'
import { Loading } from 'element-ui'
import { fetchLanguage } from '@/api/language'

import elementEnLocale from 'element-ui/lib/locale/lang/en' // element-ui lang
import elementFrLocale from 'element-ui/lib/locale/lang/fr' // element-ui lang
import elementZhLocale from 'element-ui/lib/locale/lang/zh-CN'// element-ui lang

import enLocale from './en'
import zhLocale from './zh-CN'
import frLocale from './fr'

Vue.use(VueI18n)

const messages = {
  zh_CN: {  //Chinese 中文
    ...zhLocale,
    ...elementZhLocale
  },
  en_GB: {  //English 英语
    ...enLocale,
    ...elementEnLocale
  },
  fr_FR: {  //English 英语
    ...frLocale,
    ...elementFrLocale
  }
}

export function getLanguage() {
  const lang = localeLanguage()
  const loading = Loading.service({
    lock: true
  })
  // console.log(lang, 'lang')
  fetchLanguage({ langCode: lang }).then(response => {
    // console.log(response, 'fetchLanguage')
    const constMessages = messages[lang] || {}
    const asyncMessages = response.data || {}
    i18n.setLocaleMessage(lang, { ...constMessages, ...asyncMessages })
    loading.close()
  }).catch(() => {
    loading.close()
  })
  return lang
}

export function localeLanguage() {
  const chooseLanguage = Cookies.get('language')
  if (chooseLanguage) {
    return chooseLanguage
  }

  let language = navigator.language || navigator.browserLanguage
  if (language.indexOf('zh')>-1) {
    language = 'zh_CN'
  } else if (language.indexOf('en')>-1) {
    language = 'en_GB'
  }else if (language.indexOf('fr')>-1) {
    language = 'fr_FR'
  }
  const locales = Object.keys(messages)
  for (const locale of locales) {
    if (language.indexOf(locale) > -1) {
      return locale
    }
  }
  return 'en'
}

const i18n = new VueI18n({
  locale: localeLanguage(),
  messages,
  silentTranslationWarn: true,
  fallbackLocale: 'zh_CN'
})

export default i18n
